import { AssetsSection } from './assetsSection';

export const Assets = () => {
  return <AssetsSection />;
};
